/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAllCollapsed } from "../context/all-collapsed";

/**
 * Determine if the given item was the last to be added to its list of items.
 * @param {string} guid
 * @param {(state: Record<string, unknown>) => NullableString} selectLastItem
 * @param {import('@reduxjs/toolkit').ActionCreatorWithPayload<NullableString>} setLastAdded
 */
const useIsLastAddedScroll = (guid, selectLastItem, setLastAdded) => {
    const { clearCollapse } = useAllCollapsed();
    const dispatch = useDispatch();
    
    const onScroll = useCallback(() => {
        dispatch(setLastAdded(null));
        clearCollapse();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const lastGuid = useSelector(selectLastItem);
    const isLast = guid === lastGuid;

    return {
        isLast,
        onScroll
    };
};

export { useIsLastAddedScroll };


/**
 * @typedef {string | null} NullableString
 */
